 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import RONCARLSON24 from '@/components/RonCarlson-24'
 import DED from '@/components/ded'
 import RONCARLSON25 from '@/components/RonCarlson-25'
 import RONCARLSON26 from '@/components/RonCarlson-26'
 import RONCARLSON28 from '@/components/RonCarlson-28'
 import RONCARLSON29 from '@/components/RonCarlson-29'
 import RONCARLSON30 from '@/components/RonCarlson-30'
 import RONCARLSON32 from '@/components/RonCarlson-32'
 import RONCARLSON33 from '@/components/RonCarlson-33'
 import RONCARLSON34 from '@/components/RonCarlson-34'
 import RONCARLSON35 from '@/components/RonCarlson-35'
 import RONCARLSON36 from '@/components/RonCarlson-36'
 import RONCARLSON37 from '@/components/RonCarlson-37'
 import RONCARLSON38 from '@/components/RonCarlson-38'
 import RONCARLSON39 from '@/components/RonCarlson-39'
 import RONCARLSON40 from '@/components/RonCarlson-40'
 import RONCARLSON41 from '@/components/RonCarlson-41'
 import RONCARLSON42 from '@/components/RonCarlson-42'
 import RONCARLSON43 from '@/components/RonCarlson-43'
 import RONCARLSON44 from '@/components/RonCarlson-44'
 import RONCARLSON45 from '@/components/RonCarlson-45'
 import RONCARLSON46 from '@/components/RonCarlson-46'
 import RONCARLSON47 from '@/components/RonCarlson-47'
 import RONCARLSON48 from '@/components/RonCarlson-48'
 import RONCARLSON49 from '@/components/RonCarlson-49'
 import RONCARLSON50 from '@/components/RonCarlson-50'
 import RONCARLSON51 from '@/components/RonCarlson-51'
 import LOVE_2 from '@/components/love_2'
 import RONCARLSON52 from '@/components/RonCarlson-52'
 import ABA from '@/components/aba'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/RonCarlson-24",
 			"name" : "RonCarlson-24",
 			"component" : RONCARLSON24
 		},
 		{
 			"path" : "/ded",
 			"name" : "ded",
 			"component" : DED
 		},
 		{
 			"path" : "/RonCarlson-25",
 			"name" : "RonCarlson-25",
 			"component" : RONCARLSON25
 		},
 		{
 			"path" : "/RonCarlson-26",
 			"name" : "RonCarlson-26",
 			"component" : RONCARLSON26
 		},
 		{
 			"path" : "/RonCarlson-28",
 			"name" : "RonCarlson-28",
 			"component" : RONCARLSON28
 		},
 		{
 			"path" : "/RonCarlson-29",
 			"name" : "RonCarlson-29",
 			"component" : RONCARLSON29
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js